import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_FINAL_REPORT_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_FINAL_REPORT> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_FINAL_REPORT = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page2[0]",
	fireInsurance: 'topmostSubform[0].Page2[0].FIRE_INSURANCE[0]',
	// "3":"topmostSubform[0].Page2[0].NOTARY_SIGNATORY[0]",
	notaryInfo5: 'topmostSubform[0].Page2[0].NOTARY_INFO5[0]',
	notaryInfo4: 'topmostSubform[0].Page2[0].NOTARY_INFO4[0]',
	notaryInfo3: 'topmostSubform[0].Page2[0].NOTARY_INFO3[0]',
	notaryInfo2: 'topmostSubform[0].Page2[0].NOTARY_INFO2[0]',
	notaryInfo1: 'topmostSubform[0].Page2[0].NOTARY_INFO1[0]',
	restrictionC: 'topmostSubform[0].Page2[0].RESTRICTIONS_C[0]',
	restrictionB: 'topmostSubform[0].Page2[0].RESTRICTIONS_B[0]',
	restrictionA: 'topmostSubform[0].Page2[0].RESTRICTIONS_A[0]',
	fireInsuranceCondoBranch:
		'topmostSubform[0].Page2[0].FIRE_INS_BRANCH_CONDO[0]',
	fireInsuranceCondoExpiryDate:
		'topmostSubform[0].Page2[0].FIRE_INS_DATE_CONDO[0]',
	fireInsuranceCondoPolicyNumber:
		'topmostSubform[0].Page2[0].FIRE_INS_NUMBER_CONDO[0]',
	fireInsuranceCondoWith: 'topmostSubform[0].Page2[0].FIRE_INS_NAME_CONDO[0]',
	fireInsuranceCondoAmount:
		'topmostSubform[0].Page2[0].FIRE_INS_AMOUNT_CONDO[0]',
	fireInsuranceBranch: 'topmostSubform[0].Page2[0].FIRE_INS_BRANCH[0]',
	fireInsuranceExpiryDate: 'topmostSubform[0].Page2[0].FIRE_INS_DATE[0]',
	fireInsurancePolicyNumber: 'topmostSubform[0].Page2[0].FIRE_INS_NUMBER[0]',
	fireInsuranceWith: 'topmostSubform[0].Page2[0].FIRE_INS_NAME[0]',
	fireInsuranceAmount: 'topmostSubform[0].Page2[0].FIRE_INS_AMOUNT[0]',
	deedOfLoan: 'topmostSubform[0].Page2[0].RANK[0]',
	// "23":"topmostSubform[0].Page1[0]",
	date: 'topmostSubform[0].Page1[0].DATE_CREATED[1]',
	// "25":"topmostSubform[0].Page1[0].FAX_NO[0]",
	taxRollNumber: 'topmostSubform[0].Page1[0].TAX_ROLL_NUMBER[0]',
	paidTaxesDate: 'topmostSubform[0].Page1[0].TAXES_DATE[0]',
	registryOffice: 'topmostSubform[0].Page1[0].REGISTRY_OFFICE[0]',
	registrationDate: 'topmostSubform[0].Page1[0].REGISTRATION_DATE[0]',
	registrationNumber: 'topmostSubform[0].Page1[0].REGISTRATION_NUMBER[0]',
	paymentFrequency: 'topmostSubform[0].Page1[0].PAYMENT_FREQUENCY[0]',
	interestInstallment: 'topmostSubform[0].Page1[0].INTEREST_INSTALLMENT[0]',
	maturityDate: 'topmostSubform[0].Page1[0].MATURITY_DATE[0]',
	interestRate: 'topmostSubform[0].Page1[0].INTEREST_RATE[0]',
	mortgageAmount: 'topmostSubform[0].Page1[0].MORTGAGE_AMOUNT[0]',
	formNumber: 'topmostSubform[0].Page1[0].FORM_NO[0]',
	civicAddress: 'topmostSubform[0].Page1[0].PROPERTY_ADDRESS[0]',
	legalDescription: 'topmostSubform[0].Page1[0].LEGAL_DESCRIPTION[0]',
	propertyIdentificationNumber: 'topmostSubform[0].Page1[0].PID[0]',
	guarantor: 'topmostSubform[0].Page1[0].GUARANTOR[0]',
	borrowerName: 'topmostSubform[0].Page1[0].BORROWER[0]',
	defaultInsurerName: 'topmostSubform[0].Page1[0].DEFAULT_INSURER[0]',
	mortgageNumber: 'topmostSubform[0].Page1[0].MORTGAGE_NUMBER[0]',
	to: 'topmostSubform[0].Page1[0].BRANCH_NAME[0]',
	// date:'topmostSubform[0].Page1[0].DATE_CREATED[0]',
	// "46":"topmostSubform[0].Page1[0].BARCODE_FINAL_REPORT[0]"
};

export interface BMO_CONVENTIONAL_FINAL_REPORT {
	date: string;
	to: string;

	mortgageNumber: string;
	defaultInsurerName: string;
	borrowerName: string;
	guarantor: string;
	propertyIdentificationNumber: string;
	legalDescription: string;
	civicAddress: string;

	formNumber: string;
	mortgageAmount: string;
	interestRate: string;
	maturityDate: string;
	interestInstallment: string;
	paymentFrequency: string;

	registrationNumber: string;
	registrationDate: string;
	registryOffice: string;

	paidTaxesDate: string;
	taxRollNumber: string;

	deedOfLoan: string;

	fireInsurance: string;
	fireInsuranceAmount: string;
	fireInsuranceWith: string;
	fireInsurancePolicyNumber: string;
	fireInsuranceExpiryDate: string;
	fireInsuranceBranch: string;

	fireInsuranceCondoAmount: string;
	fireInsuranceCondoWith: string;
	fireInsuranceCondoPolicyNumber: string;
	fireInsuranceCondoExpiryDate: string;
	fireInsuranceCondoBranch: string;

	restrictionA: string;
	restrictionB: string;
	restrictionC: string;

	notaryInfo1: string;
	notaryInfo2: string;
	notaryInfo3: string;
	notaryInfo4: string;
	notaryInfo5: string;
}
